import axios from 'axios'


const state = {
  workClientInvoicingCompanyGrid: [],
  workClientInvoicingCompanyAll: [],
  workClientInvoicingCompanyShow: {
    name: null,
    logo: null,
  },
  pageData: null,
}
const mutations = {
  setWorkClientInvoicingCompanyGrid(state, payload) {
    state.workClientInvoicingCompanyGrid = payload
  },
  setWorkClientInvoicingCompanyAll(state, payload) {
    state.workClientInvoicingCompanyAll = payload
  },
  setWorkClientInvoicingCompanyShow(state, payload) {
    state.workClientInvoicingCompanyShow = payload ? payload : {}
  },
  setPageData(state, payload) {
    state.pageData = payload
  },
}
const getters = {
  workClientInvoicingCompanyGrid: (state) => {
    return state.workClientInvoicingCompanyGrid
  },
  workClientInvoicingCompanyAll: (state) => {
    return state.workClientInvoicingCompanyAll
  },
  workClientInvoicingCompanyShow: (state) => {
    return state.workClientInvoicingCompanyShow
  },
  pageData: (state) => {
    return state.pageData
  },
  workClientInvoicingCompanyShowName: (state) => {
    return state.workClientInvoicingCompanyShow.name
  },
}
const actions = {
  onWorkClientInvoicingCompanyGrid({commit, dispatch, rootState}, {limit, page, sort, search}) {
    commit('setLoadingAnimationFullPage', true, {root: true})
    let url = rootState.apiDomain + '/api/admin/work/client/invoicing-company/grid?limit=' + limit + '&page=' + page
    if (sort) {
      url = url + '&order[]=' + sort.param + ':' + sort.value
    } else {
      url = url + '&order[]=name:asc'
    }
    if (search) url = url + '&search=' + search
    return new Promise((resolve, reject) => {
      axios({
        url,
        method: 'GET',
      })
        .then((resp) => {
          commit('setWorkClientInvoicingCompanyGrid', resp.data.data)
          commit('setPageData', resp.data)
          commit('setLoadingAnimationFullPage', false, {root: true})
          resolve(resp)
        })
        .catch((err) => {
          commit('setLoadingAnimationFullPage', false, {root: true})
          reject(err)
          dispatch('popup/onMessage', {IsError: true}, {root: true})
        })
    })
  },
  onWorkClientInvoicingCompanyAll({commit, rootState}) {
    return new Promise((resolve, reject) => {
      axios({
        url: rootState.apiDomain + '/api/admin/work/client/invoicing-company/grid?limit=0' + '&order[]=name:asc',
        method: 'GET',
      })
        .then((resp) => {
          commit('setWorkClientInvoicingCompanyAll', resp.data.data)
          resolve(resp)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  onWorkClientInvoicingCompanyClear({commit}) {
    commit('setWorkClientInvoicingCompanyShow', {})
  },
  onWorkClientInvoicingCompanyShow({commit, rootState}, id) {
    commit('setLoadingAnimationFullPage', true, {root: true})
    return new Promise((resolve, reject) => {
      axios({
        url: rootState.apiDomain + '/api/admin/work/client/invoicing-company/' + id,
        id: id,
        method: 'GET',
      })
        .then((resp) => {
          commit('setWorkClientInvoicingCompanyShow', resp.data.data)
          commit('setLoadingAnimationFullPage', false, {root: true})
          resolve(resp)
        })
        .catch((err) => {
          commit('setLoadingAnimationFullPage', false, {root: true})
          reject(err)
        })
    })
  },
  onWorkClientInvoicingCompanyCreate({commit, dispatch, rootState}, data) {
    commit('setLoadingAnimationFullPage', true, {root: true})
    return new Promise((resolve, reject) => {
      axios({
        url: rootState.apiDomain + '/api/admin/work/client/invoicing-company',
        data: data,
        method: 'POST',
      })
        .then((resp) => {
          resolve(resp)
          commit('setLoadingAnimationFullPage', false, {root: true})
          dispatch('popup/onMessage', {
            message: rootState.translations.notifications['uspeshno-dobavlen'],
            IsError: false
          }, {root: true})
        })
        .catch((err) => {
          commit('setLoadingAnimationFullPage', false, {root: true})
          dispatch('popup/onMessage', {IsError: true}, {root: true})
          reject(err)
        })
    })
  },
  onWorkClientInvoicingCompanyUpdate({commit, dispatch, rootState}, data) {
    return new Promise((resolve, reject) => {
      axios({
        url: rootState.apiDomain + '/api/admin/work/client/invoicing-company/' + data.id,
        data: data,
        method: 'PUT',
      })
        .then((resp) => {
          resolve(resp)
          dispatch('popup/onMessage', {IsError: false}, {root: true})
        })
        .catch((err) => {
          reject(err)
          dispatch('popup/onMessage', {IsError: true}, {root: true})
        })
    })
  },
  onWorkClientInvoicingCompanyDelete({commit, dispatch, rootState}, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: rootState.apiDomain + '/api/admin/work/client/invoicing-company/' + id,
        id: id,
        method: 'DELETE',
      })
        .then((resp) => {
          resolve(resp)
          dispatch('popup/onMessage', {IsError: false}, {root: true})
        })
        .catch((err) => {
          reject(err)
          dispatch('popup/onMessage', {IsError: true}, {root: true})
        })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
